import dashboardTypes from './dashboardTypes'

export const getQuickNumbers = () => ({
  type: dashboardTypes.FETCH_QUICK_NUMBERS
})

export const getQuickNumbersSuccess = (payload) => ({
  type: dashboardTypes.FETCH_QUICK_NUMBERS_SUCCESS,
  payload
})

export const getQuickNumbersFailure = (payload) => ({
  type: dashboardTypes.FETCH_QUICK_NUMBERS_FAILURE,
  payload
})

export const getEvents = () => ({
  type: dashboardTypes.FETCH_EVENTS
})

export const getEventsSuccess = (payload) => ({
  type: dashboardTypes.FETCH_EVENTS_SUCCESS,
  payload
})

export const getEventsFailure = (payload) => ({
  type: dashboardTypes.FETCH_EVENTS_FAILURE,
  payload
})
